import React from 'react';
import MembershipContent from '../components/MembershipContent';
import '../styles/Membership.css';

const Membership = ({ language }) => {
  return (
    <>
      <MembershipContent language={language} />
    </>
  );
};

export default Membership;
